<template>
  <b-container fluid class="module-header px-0">
    <b-row no-gutters>
      <b-card class="module-header w-100">
        <b-container
          class="position-relative"
          fluid
        >
          <b-row
            align-h="between"
            align-v="center"
          >
            <b-col
              class="module-header__image-container d-inline-flex justify-content-center"
              cols="12"
              sm="2"
            >
              <div
                class="module-header__image"
                :style="imageStyleDefinition"
              />
            </b-col>
            <b-col
              class="module-header__title"
              cols="12"
              sm="8"
              lg="8"
            >
              <h2 class="h1">{{ value.name }}</h2>
            </b-col>
            <b-col
              class="module-header__btns"
              cols="12"
              sm="2"
              lg="2"
              align-self="center"
            >
              <div
                class="text-center"
                :class="{ 'mb-3': lastUpdate }"
                v-if="!noButtons"
              >
                <i
                  class="fas fa-sync mr-1"
                  id="refreshButton"
                  role="button"
                  slot="icon"
                  @click="refreshModule"
                  v-if="!hideUpdateButton"
                />
                <i
                  class="fas fa-print mr-1"
                  id="printButton"
                  role="button"
                  slot="icon"
                  @click="sendPrintEvent()"
                  v-if="!hidePrintButton"
                />
                <i
                  class="fas fa-info-circle mr-1"
                  id="infoButton"
                  role="button"
                  slot="icon"
                  @click="goToPage('monitoring.asset-information.asset')"
                />
                <i
                  class="fas fa-wifi mr-1"
                  id="wifiButton"
                  role="button"
                  slot="icon"
                  @click="goToPage('monitoring.supervision.digital-network')"
                />
              </div>
            </b-col>
          </b-row>
          <b-row
            v-show="lastUpdate"
            class="module-header__last-update-wrapper"
          >
            <b-col class="module-header__last-update">
              <strong>{{ $t('engineering.last-update') }}:</strong>
              <span>{{
                this.lastUpdate | dateTimeFilter({ format: formats.DATETIME_SHORT })
              }}</span>
            </b-col>
          </b-row>
        </b-container>
      </b-card>
    </b-row>
  </b-container>
</template>

<script>
import print from '@/services/print';
import globalEventBus from '@/services/globalEventBus';
import engineeringEvents from '@/domain/events/engineering';
import { formats } from '@/constants/localizer';

export default {
  props: {
    value: Object,
    noButtons: {
      type: Boolean,
      default: false,
    },
    hidePrintButton: {
      type: Boolean,
      default: false,
    },
    hideUpdateButton: {
      type: Boolean,
      default: false,
    },
    imageUrl: {
      type: String,
      required: false,
    },
    lastUpdate: {
      type: String,
    },
  },
  data: () => ({ formats }),
  computed: {
    finalImageUrl() {
      return this.imageUrl || this.value.imageUrl;
    },
    imageStyleDefinition() {
      if (this.finalImageUrl == null) {
        return '';
      }

      return `background-image: url('${this.finalImageUrl}');`;
    },
  },
  methods: {
    print,
    sendPrintEvent() {
      globalEventBus.emit(engineeringEvents.print);
      this.$nextTick(() => {
        this.print();
      });
    },
    goToPage(route) {
      const { installationId, assetId } = this.$route.params;

      const routeData = this.$router.resolve({
        name: route,
        params: {
          installationId,
          assetId,
        },
      });
      return window.open(routeData.href, '_blank');
    },
    refreshModule({ wait }) {
      this.$emit('refresh-data', { wait });
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.module-header
  background: transparent
  &__title
    color: var(--font-color-primary)
    text-align: center
  &__image
    width: 100px
    height: 100px
    background-position: 50% 50%
    background-repeat: no-repeat
    background-size: contain
  &__button
    min-width: 7rem
  &__last-update-wrapper
    position: absolute
    bottom: 0
    right: 15px
    +media-max-md
      margin-top: 5px
      position: static
  &__last-update
    color: var(--color-gray-intermediary)
    text-align: right
    font-size: .85rem
  .card-body
    padding: 8px 0

  @media print
    &__last-update-wrapper
      position: absolute
    &__title
      text-align: center
      max-width: 70%
    &__image-container
      max-width: 15%
    &__btns
      max-width: 15%
      visibility: hidden
  @media screen
    +media-max-sm()
      .module-header
        &__image-container,
        &__title,
        &__btns
          flex: 0 0 100%
          max-width: 100%
</style>
